import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs';
import { FC } from 'react';
import { AnalyticsPage, FilterValuesStrings } from './analytics.page';
import { Box, Skeleton } from '@mui/material';
import { useGetDistrictQuery } from '../../../store/api/district.api';
import { useDecodePublicLinkDataQuery } from '../../../../src/store/api/analytics.api';
import ForbiddenPage from '../../_core/pages/forbidden/forbidden.page';

export const PublicAnalyticsPage: FC = () => {
	const location = useLocation();
	const query = new URLSearchParams(location.search);
	const encrypted = query.get('data');

	const {
		data: decryptedQueryData,
		isFetching: isDecodeFetching,
		isLoading: isDecodeLoading,
	} = useDecodePublicLinkDataQuery({ data: encrypted ?? '' }, { skip: !encrypted });

	const decryptedFilters = decryptedQueryData?.filters;
	const decryptedToken = decryptedQueryData?.token;

	const start = decryptedFilters?.duration?.[0] ? dayjs(decryptedFilters.duration[0]).toDate() : null;
	const end = decryptedFilters?.duration?.[1] ? dayjs(decryptedFilters.duration[1]).toDate() : null;

	const duration: [Date | null, Date | null] = [start, end];

	const transformedFilterValues: FilterValuesStrings = {
		districtIds: decryptedFilters?.districtIds || '',
		engagementTypes: decryptedFilters?.engagementTypes || '',
		schoolIds: decryptedFilters?.schoolIds || '',
		programIds: decryptedFilters?.programIds || '',
		serviceIds: decryptedFilters?.serviceIds || '',
		providerIds: decryptedFilters?.providerIds || '',
		languages: decryptedFilters?.languages || '',
		engagementStatuses: decryptedFilters?.engagementStatuses || '',
		duration,
	};
	const districtId = decryptedFilters?.districtIds?.split(',')?.[0] || null;
	const { data: currentDistrict } = useGetDistrictQuery(
		{ id: districtId },
		{ skip: !districtId && !isDecodeFetching && !isDecodeLoading }
	);

	if (isDecodeFetching || isDecodeLoading) {
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<Skeleton width={48} height={48} variant="circular" />
			</Box>
		);
	}

	if (!decryptedToken) {
		return <ForbiddenPage />;
	}

	return (
		<Box sx={{ overflowY: 'auto' }}>
			<AnalyticsPage
				transformedFilterValues={transformedFilterValues}
				isReadOnly
				isPublic
				isAdminRoute={false}
				currentDistrictId={districtId}
				currentDistrict={currentDistrict}
				authToken={decryptedToken}
			/>
		</Box>
	);
};
